export const CEDE_X_ACCOUNT_ID = "1495011931778084872";
